var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-gutter-x-md"},_vm._l((_vm.radioOpts),function(r){return _c('q-radio',{key:r.val,attrs:{"size":"sm","dense":"","val":r.val,"label":r.label,"value":_vm.radioValue},on:{"input":_vm.onRadioInput}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }